import axios from "axios";

//IMPORT API ROUTE URL
import { GET_FIRMS_IN_NETWORK_ROUTE } from "./apiRoutes";

const getFirmsInNetwork = (user_slug, filterText) => {
  var postData = new FormData();

  postData.append("user_slug", user_slug);

  return axios
    .post(GET_FIRMS_IN_NETWORK_ROUTE, postData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default getFirmsInNetwork;
